import React, { useEffect, useRef, useState } from 'react';
import styled, { cutDates, inputStyles, stockNumber } from '../../Utils/inputChanges';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize, Checkbox

} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import TitleBar from '../TitleBar';
import { PackingMenu } from '../TitleList';
import { selectFirm, selectlocationdata, selectParty, selectSchool, selectTransports } from '../Selectors/Master/ItemSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { fetchPartyData, fetchSingleParty } from '../../Store/PHPSlice/Party';
import { fetchLocationData, fetchTransportData } from '../../Store/PHPSlice/Transport';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Dropdown from '../FieldsComponents/Dropdown';
import TextareaComponent from '../FieldsComponents/TextareaComponent';
import { fetchSchoolData } from '../../Store/PHPSlice/School';
import { fetchPackingSlipMemo, fetchStkOnlyManualbarcode, fetchStkOrderManualbarcode, insertPackingEntry } from '../../Store/PHPSlice/Packing/PackApis';
import { selectPackingSlipMemo, selectStkOnlyManualnos, selectStkOrderManualnos } from '../Selectors/PackSelector/PackingSelector';
import axios from 'axios';
import RadioComponent from '../FieldsComponents/RadioComponent';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';


const PackingEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        barcode: '',
        eType: '1',
        pkMemo: '',
        baleNo: '',
        firm: '',
        party: '',
        adrs: '',
        trspt: '',
        shtoNm: '',
        shtoadrs: '',
        parcelqty: '',
        remark: '',
        item: '',
        schlNm: '',
        totQty: '',
        ordMan: '',
        soId: '',
        types: '1',
        scanBar: '',
        locId: '',
        ordtypes: 'Sale Order',
        userId: userdata?.ID
    });
    const debounceTimeout = useRef(null);
    const [packData, setPackData] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [saleordlist, setSaleordlist] = useState([]);
    const [soItemlist, setSoItemlist] = useState([]);
    const [selectedParty, setSelectedParty] = useState([]);

    const dispatch = useDispatch();
    const firmlist = useSelector(selectFirm);
    const partylist = useSelector(selectParty);
    const transportlist = useSelector(selectTransports);
    const schlist = useSelector(selectSchool);

    const stkOrdManualnos = useSelector(selectStkOrderManualnos);
    const stkOnlyManualnos = useSelector(selectStkOnlyManualnos);
    const packMemo = useSelector(selectPackingSlipMemo);
    const locdata = useSelector(selectlocationdata);
    const baseUrl = process.env.REACT_APP_BASE_URL;

    const [openDropdowns, setOpenDropdowns] = useState({});


    const actionMap = {
        party: fetchPartyData
        // Add more mappings if needed
    };

    useEffect(() => {
        dispatch(fetchCompanyData());
        dispatch(fetchPartyData());
        dispatch(fetchTransportData());
        dispatch(fetchSchoolData());
        dispatch(fetchStkOrderManualbarcode());
        dispatch(fetchStkOnlyManualbarcode());
        dispatch(fetchPackingSlipMemo());
        dispatch(fetchLocationData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    useEffect(() => {
        if (packMemo?.data && packMemo.data?.pkMemo) {
            const Id = packMemo.data.pkMemo;
            setFormData(prev => ({
                ...prev,
                pkMemo: Id
            }));
        }
    }, [packMemo]);

    useEffect(() => {
        if (selectedParty?.length > 0) {
            const data = selectedParty[0]
            setFormData(prev => ({
                ...prev,
                adrs: data?.adrs
            }));
        }
    }, [selectedParty]);

    const isDesktop = useMediaQuery('(min-width:768px)');
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

        // if (name === 'scanBar' && value) {
        //     const data12 = {
        //         scanBar: value,
        //         type: formData.eType
        //     };
        //     fetchBarcodeData(data12);

        //     setTimeout(() => {
        //         setFormData({
        //             ...formData,
        //             scanBar: ''
        //         });
        //     }, 1000);

        // }


        if (name === 'scanBar') {
            // Clear the previous debounce timer
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }

            // Set a new debounce timer
            debounceTimeout.current = setTimeout(() => {
                if (value) {
                    const data12 = {
                        scanBar: value,
                        type: formData.eType
                    };
                    fetchBarcodeData(data12);

                    // Optionally clear the scanBar field after call
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        scanBar: ''
                    }));
                }
            }, 1000); // delay in milliseconds
        }
    };

    const handleDropdownChange = async (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

        switch (dropdownType) {
            case 'ordMan':
                if (value) {
                    setFormData(prev => ({
                        ...prev,
                        ordMan: '' // Reset to clear the field
                    }));
                    fetchSktSingleRecords(value);
                    setSelectedItems(prev => [...prev, value]);
                }
                break;
            case 'firm':
                if (value && formData.party !== '') {
                    const data = {
                        firmId: value,
                        partyId: formData.party
                    };
                    fetchPartyWiseSaleOrder(data);
                } else {
                    setSaleordlist([]);
                }
                break;
            case 'party':
                if (value && formData.firm !== '') {
                    const data = {
                        firmId: formData.firm,
                        partyId: value
                    };
                    fetchPartyWiseSaleOrder(data);
                    fetchSelectParty(value);
                } else {
                    setSaleordlist([]);
                }
                break;
            case 'soId':
                if (value) {
                    fetchSOItems(value);
                } else {
                    setSoItemlist([]);
                }
                break;

            default:
                break;
        }
    };

    const handleQuantityChange = (index, name, value) => {
        // Make a copy of packData
        const updatedPackData = [...packData];

        // Ensure the value is a valid number
        const newValue = parseFloat(value) || 0;

        // Update either rate or qty based on the input field
        if (name === "rate") {
            updatedPackData[index].rate = newValue;
        } else if (name === "qty") {
            // If entered qty is greater than stkqty, set qty to stkqty
            const stkqty = updatedPackData[index].stkqty || 0; // Ensure stkqty is a number
            if (newValue > stkqty) {
                updatedPackData[index].qty = stkqty; // Set qty to stkqty if the entered value exceeds stkqty
            } else {
                updatedPackData[index].qty = newValue; // Otherwise, set qty to entered value
            }
        }

        // Recalculate totalqty (total = rate * qty)
        const qty = updatedPackData[index].qty || 0;  // Ensure qty is a number
        const rate = updatedPackData[index].rate || 0;  // Ensure rate is a number
        updatedPackData[index].totalqty = qty * rate;

        // Handle balqty logic based on stkqty and qty
        const stkqty = updatedPackData[index].stkqty || 0; // Ensure stkqty is a number
        let balqty = 0;
        if (qty > stkqty) {
            // If entered qty is more than stkqty, set balqty to stkqty
            balqty = stkqty;
        } else {
            // Otherwise, set balqty to stkqty - qty
            balqty = stkqty - qty;
        }

        updatedPackData[index].balqty = balqty;

        const totalQty = updatedPackData.reduce((sum, item) => sum + parseFloat(item.qty || 0), 0);

        // Update state
        setPackData(updatedPackData);
        setFormData(prev => ({
            ...prev,
            totQty: totalQty
        }));
    };

    const handleSelectChange = (index) => {
        // Toggle selection for the row at the given index
        setSelectedRows((prevSelectedRows) => {
            if (prevSelectedRows.includes(index)) {
                // If already selected, remove it from the array
                return prevSelectedRows.filter(item => item !== index);
            } else {
                // Otherwise, add it to the array
                return [...prevSelectedRows, index];
            }
        });
    };

    const handleDelete = () => {
        // Step 1: Remove selected items from packData
        setPackData((prevPackData) => {
            const newPackData = prevPackData.filter((item, index) => !selectedRows.includes(index));

            // Step 2: Remove the corresponding items from selectedItems
            setSelectedItems((prevSelectedItems) => {
                // Find the IDs of the items to be removed (those in selectedRows)
                const itemsToRemove = selectedRows
                    .map(index => prevPackData[index]?.ID) // Get the IDs of the items in selectedRows
                    .filter(id => id !== undefined); // Filter out undefined values (in case the index is invalid)

                // Remove these IDs from selectedItems
                return prevSelectedItems.filter(id => !itemsToRemove.includes(id));
            });

            return newPackData;
        });

        // Step 3: Clear selected rows after deletion
        setSelectedRows([]);

        const updatedPackData = [...packData];
        const totalQty = updatedPackData.reduce((sum, item) => sum + (item.qty || 0), 0);
        setFormData(prev => ({
            ...prev,
            totQty: totalQty
        }));
    };

    const handleRadioChange = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
            barcode: '',
            baleNo: '',
            firm: '',
            party: '',
            adrs: '',
            trspt: '',
            shtoNm: '',
            shtoadrs: '',
            parcelqty: '',
            remark: '',
            item: '',
            schlNm: '',
            totQty: '',
            ordMan: '',
            soId: '',
            scanBar: '',
            locId: '',
        });
        if (event.target.name === 'eType') {
            setPackData([]);
        }
    };

    const fetchSktSingleRecords = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getStkDataSingleRecord&stkId=${id}`);
            let itemData = response.data.data;
            // Add new keys with the specified values
            // console.log(itemData)
            itemData = {
                ...itemData,
                balqty: itemData.stkqty || 0,  // balqty is the same as stkqty, or 0 if undefined
                qty: 0,  // default value for qty
                totalqty: 0,  // default value for total
                rate: 0  // default value for rate
            };
            setPackData(prev => Array.isArray(prev) ? [...prev, itemData] : [itemData]);
        } catch (error) {
            console.error('Error fetching title list:', error);
            setPackData([]);
        }
    };

    const fetchSelectParty = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getPartylist&partyId=${id}`);
            const data = response.data.data;
            // Add new keys with the specified values
            // console.log(itemData)
            setSelectedParty(data);
        } catch (error) {
            console.error('Error fetching title list:', error);
            setSelectedParty([]);
        }
    };


    const fetchPartyWiseSaleOrder = async (id) => {
        const { firmId, partyId } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getSaleOrderFirmParty&firmId=${firmId}&partyId=${partyId}`);
            let itemData = response.data.data;
            // Add new keys with the specified values
            // console.log(itemData)
            setSaleordlist(itemData);

        } catch (error) {
            console.error('Error fetching title list:', error);

        }
    };

    const fetchSOItems = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getStkProdWithSO&soId=${id}`);
            let itemData = response.data.data;
            // Add new keys with the specified values
            // console.log(itemData)
            setSoItemlist(itemData);

        } catch (error) {
            console.error('Error fetching title list:', error);

        }
    };

    const fetchBarcodeData = async (id) => {
        const { scanBar, type } = id;

        try {
            const response = await axios.get(`${baseUrl}?apicall=getScanBarcode&scanBar=${scanBar}`);
            let itemData = response.data.data;

            if (!itemData) {
                alert('Stock Not Available');
                return;
            }

            const items = itemData;

            const updatedData = [...packData];
            let added = false;
            let alreadyExists = false;

            const exists = updatedData.find(item => item.ID === items.ID);

            if (!exists) {
                updatedData.push({
                    ...items,
                    balqty: items.stkqty || 0,
                    qty: 0,
                    totalqty: 0,
                    rate: 0
                });
                added = true;
            } else {
                alreadyExists = true;
            }

            // Now update the state
            setPackData(updatedData);

            if (alreadyExists) {
                alert('Item already exists');

            }

        } catch (error) {
            console.error('Error fetching barcode data:', error);
        }
    };


    const fields = [
        { label: 'Date', name: 'dt', type: 'date' },
        { label: 'Packing Slip Memo', name: 'pkMemo', type: 'readOnly' }
    ];


    const handlePartyNew = () => {
        window.open(`/NewPartyEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownlistfirst = [
        {
            label: 'Firm',
            id: 'firm',
            options: firmlist?.data,
            value: formData.firm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Party',
            id: 'party',
            options: partylist?.data,
            value: formData.party,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'party', value: newValue ? newValue.ID : '' } }, 'party'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handlePartyNew(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('party'),
            handleDropdownClose: () => handleDropdownClose('party'),
        }
    ];

    const dropdownlistsecond = [
        {
            label: 'School',
            id: 'schlNm',
            options: schlist?.data,
            value: formData.schlNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlNm', value: newValue ? newValue.ID : '' } }, 'schlNm'),
            getOptionLabel: (option) => option.schoolNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Transport',
            id: 'trspt',
            options: transportlist?.data,
            value: formData.trspt,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'trspt', value: newValue ? newValue.ID : '' } }, 'trspt'),
            getOptionLabel: (option) => option.transportNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const dropdownShifting = [
        {
            label: 'School',
            id: 'schlNm',
            options: schlist?.data || [],
            value: formData.schlNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlNm', value: newValue ? newValue.ID : '' } }, 'schlNm'),
            getOptionLabel: (option) => option.schoolNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Location',
            id: 'locId',
            options: locdata?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const filterSelectedItems = (options) => {
        return options.filter(option => !selectedItems.includes(option.ID));
    };
    // console.log(soItemlist);

    const ItemConfig = {
        'Sale Order': {
            label: 'Item',
            id: 'ordMan',
            // options: formData.soId !== '' ? filterSelectedItems(soItemlist) : filterSelectedItems(stkOrdManualnos?.data) || [],
            options: filterSelectedItems(soItemlist) || [],
            value: formData.ordMan || '',
            onChange: (newValue) => handleDropdownChange({ target: { name: 'ordMan', value: newValue ? newValue.ID : '' } }, 'ordMan'),
            getOptionLabel: (option) => option.order_no || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        'Garment': {
            label: 'Item',
            id: 'ordMan',
            options: filterSelectedItems(stkOnlyManualnos?.data) || [],
            value: formData.ordMan || '',
            onChange: (newValue) => handleDropdownChange({ target: { name: 'ordMan', value: newValue ? newValue.ID : '' } }, 'ordMan'),
            getOptionLabel: (option) => option.order_no || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        'Manual Production': {
            label: 'Item',
            id: 'ordMan',
            options: filterSelectedItems(stkOrdManualnos?.data) || [],
            value: formData.ordMan || '',
            onChange: (newValue) => handleDropdownChange({ target: { name: 'ordMan', value: newValue ? newValue.ID : '' } }, 'ordMan'),
            getOptionLabel: (option) => option.order_no || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    };

    const saleConfig = {
        '1': {
            label: 'Sale Order',
            id: 'soId',
            options: saleordlist || [],
            value: formData.soId || '',
            onChange: (newValue) => handleDropdownChange({ target: { name: 'soId', value: newValue ? newValue.ID : '' } }, 'soId'),
            getOptionLabel: (option) => option.sono || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }

    };

    const dropdownlistthird = ItemConfig[formData.ordtypes];
    const saleOrdfourth = saleConfig[formData.eType];

    const adrss = [
        { label: 'Address', name: 'adrs' },
        { label: 'Ship To Name', name: 'shtoNm' },
        { label: 'Ship To Address', name: 'shtoadrs' },
    ];

    const fieldsecond = [
        { label: 'Parcel Qty', name: 'parcelqty' },
        { label: 'Remark', name: 'remark' },
        { label: 'Total Qty', name: 'totQty', type: 'readOnly' }
    ];

    const options = [
        { value: '1', label: 'Order + Manual' },
        { value: '2', label: 'Manual' },
        { value: '3', label: 'Shifting' }
    ];


    const typesOptions = [
        { value: '1', label: 'Manual' },
        { value: '2', label: 'Barcode' },
    ];

    const scanBarcode = [
        { label: 'Barcode', name: 'scanBar' },
    ];

    const orderTypes = [
        { label: 'Sale Order', ID: 'Sale Order' },
        { label: 'Manual Production', ID: 'Manual Production' },
        { label: 'Garment', ID: 'Garment' }
    ];

    const orderTypes2 = [
        { label: 'Manual Production', ID: 'Manual Production' },
        { label: 'Garment', ID: 'Garment' }
    ];

    const dropdownOrdTypes = [
        {
            label: 'Order Types',
            id: 'ordtypes',
            options: formData.eType === '2' ? orderTypes2 : orderTypes || [],
            value: formData.ordtypes,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'ordtypes', value: newValue ? newValue.ID : '' } }, 'ordtypes'),
            getOptionLabel: (option) => option.label || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    function object(formData, packData) {
        const locNm = locdata?.data?.find(item => item.ID === formData.locId)?.locNm;
        const data = {
            dt: formData.dt,
            eType: formData.eType,
            pkMemo: formData.pkMemo,
            firmId: formData.firm,
            partyId: formData.party,
            adrs: formData.adrs,
            trnsptId: formData.trspt,
            schlId: formData.schlNm,
            shipNm: formData.shtoNm,
            ship_adrs: formData.shtoadrs,
            parcelqty: formData.parcelqty,
            remark: formData.remark,
            totqty: formData.totQty,
            userId: formData.userId,
            locNm: locNm === " " ? '-' : locNm,
            locId: formData.locId,
            soId: formData.soId,
            packData: packData
        };
        return data;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }
        const finalObject = object(formData, packData);
        // console.log(finalObject);

        dispatch(insertPackingEntry(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Records Inserted");
                window.location.reload();
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };
    return (
        <>
            <TitleBar data={PackingMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <div style={{ display: 'flex', gap: '5vh' }}>
                    <h2>Packing Entry</h2>
                    <RadioComponent
                        name="eType"
                        value={formData.eType}
                        options={options}
                        onChange={handleRadioChange}
                        isDesktop={true} // Pass the actual value based on screen size
                    />
                </div>


                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {fields?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {
                                    formData.eType !== '3' && dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                {formData.eType !== '3' && adrss?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {
                                    formData.eType !== '3' && dropdownlistsecond && dropdownlistsecond.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }


                                {
                                    formData.eType === '3' && dropdownShifting && dropdownShifting.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }



                                {fieldsecond?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {/* <TextareaComponent
                                    label="Naration"
                                    name="nartn"
                                    value={formData.nartn}
                                    onChange={handleInputChange}
                                    isDesktop={isDesktop}
                                /> */}

                                {dropdownOrdTypes?.map((drop) => (
                                    <Dropdown
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                    />
                                ))}

                                {
                                    formData.ordtypes === 'Sale Order' && saleOrdfourth &&
                                    <Dropdown
                                        key={saleOrdfourth.label}
                                        label={saleOrdfourth.label}
                                        id={saleOrdfourth.id}
                                        options={saleOrdfourth.options}
                                        value={saleOrdfourth.value}
                                        onChange={saleOrdfourth.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={saleOrdfourth.getOptionLabel}
                                        isOptionEqualToValue={saleOrdfourth.isOptionEqualToValue}
                                        valueFinder={saleOrdfourth.valueFinder}  // Pass `valueFinder` function here
                                    />
                                }

                                <RadioComponent
                                    label="Item Type:"
                                    name="types"
                                    value={formData.types}
                                    options={typesOptions}
                                    onChange={handleRadioChange}
                                    isDesktop={true} // Pass the actual value based on screen size
                                />

                                {
                                    formData.types === '1' && dropdownlistthird &&
                                    <Dropdown
                                        key={dropdownlistthird.label}
                                        label={dropdownlistthird.label}
                                        id={dropdownlistthird.id}
                                        options={dropdownlistthird.options}
                                        value={dropdownlistthird.value}
                                        onChange={dropdownlistthird.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={dropdownlistthird.getOptionLabel}
                                        isOptionEqualToValue={dropdownlistthird.isOptionEqualToValue}
                                        valueFinder={dropdownlistthird.valueFinder}  // Pass `valueFinder` function here
                                    />
                                }

                                {formData.types === '2' && scanBarcode?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                <Grid item xs={6}>
                                    <Button variant="contained" color="primary" size='small' disabled={selectedRows.length === 0} onClick={handleDelete}>Delete</Button>
                                </Grid>

                                {Array.isArray(packData) && packData.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table style={isDesktop ? { width: '70%' } : { width: '100%' }}>
                                                <TableBody>

                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>
                                                            <input
                                                                type="checkbox"
                                                                onChange={() => {
                                                                    // Select all checkboxes when the header checkbox is toggled
                                                                    if (selectedRows.length === packData.length) {
                                                                        setSelectedRows([]); // Deselect all if already selected
                                                                    } else {
                                                                        setSelectedRows(packData.map((_, index) => index)); // Select all
                                                                    }
                                                                }}
                                                                checked={selectedRows.length === packData.length}
                                                            />Select
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Item</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Size</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Rate</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Stock Qty.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Damage Qty</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Qty</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Balance Qty.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Total Qty.</TableCell>
                                                    </TableRow>
                                                    {
                                                        packData.map((item, index) => (
                                                            <TableRow key={index}>

                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedRows.includes(index)}
                                                                        onChange={() => handleSelectChange(index)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{index + 1}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.order_no}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.size}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.rate || '0'}  // Ensure value is either the number or an empty string
                                                                        name="rate"
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                        onChange={(e) => handleQuantityChange(index, 'rate', e.target.value)}  // Handle rate change
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.stkqty}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.dqty}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.qty || '0'}  // Ensure value is either the number or an empty string
                                                                        name="qty"
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                        max={item.stkqty}
                                                                        onChange={(e) => handleQuantityChange(index, 'qty', e.target.value)}  // Handle qty change
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.balqty || '0'}  // Show balance qty
                                                                        name="balqty"
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                        readOnly
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.totalqty || '0'}  // Show total qty
                                                                        name="totalqty"
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                        readOnly
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </>
                                }


                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={packData.length === 0}>Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default PackingEntry;
